import { c as _c } from "react/compiler-runtime";
import { type PointerEvent, useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import { AnswerReviewEvidence, AnswerReviewWorkbenchProps } from '../AnswerReviewWorkbench.types';
export function useAnswerReviewInteractions(t0) {
  const $ = _c(23);
  const {
    focusedFieldId,
    onFocusField,
    onCloseField,
    onSelectEvidence,
    onEditingChange
  } = t0;
  const pointerId = useRef(undefined);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const pending = useRef(t1);
  const releaseTimer = useRef(undefined);
  const activeFieldId = useRef(focusedFieldId);
  let t2;
  let t3;
  if ($[1] !== focusedFieldId) {
    t2 = () => {
      activeFieldId.current = focusedFieldId;
    };
    t3 = [focusedFieldId];
    $[1] = focusedFieldId;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useLayoutEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      clearTimeout(releaseTimer.current);
      pointerId.current = undefined;
      const changes = pending.current;
      pending.current = [];
      changes.forEach(_temp);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const finishInteraction = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = change_0 => {
      if (pointerId.current === undefined) {
        change_0();
      } else {
        pending.current.push(change_0);
      }
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const afterClick = t5;
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      const handlePointerUp = event => {
        if (event.pointerId !== pointerId.current) {
          return;
        }
        releaseTimer.current = setTimeout(finishInteraction, 0);
      };
      const handlePointerCancel = event_0 => {
        if (event_0.pointerId === pointerId.current) {
          finishInteraction();
        }
      };
      window.addEventListener("click", finishInteraction);
      window.addEventListener("pointerup", handlePointerUp, true);
      window.addEventListener("pointercancel", handlePointerCancel, true);
      window.addEventListener("keydown", finishInteraction, true);
      window.addEventListener("blur", finishInteraction);
      window.addEventListener("dragstart", finishInteraction);
      return () => {
        window.removeEventListener("click", finishInteraction);
        window.removeEventListener("pointerup", handlePointerUp, true);
        window.removeEventListener("pointercancel", handlePointerCancel, true);
        window.removeEventListener("keydown", finishInteraction, true);
        window.removeEventListener("blur", finishInteraction);
        window.removeEventListener("dragstart", finishInteraction);
        clearTimeout(releaseTimer.current);
        pending.current = [];
      };
    };
    t7 = [finishInteraction];
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  useEffect(t6, t7);
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = event_1 => {
      if (event_1.button !== 0) {
        return;
      }
      finishInteraction();
      pointerId.current = event_1.pointerId;
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== onEditingChange) {
    t9 = (fieldId, isEditing) => afterClick(() => onEditingChange(fieldId, isEditing));
    $[9] = onEditingChange;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== onFocusField) {
    t10 = onFocusField ? fieldId_0 => afterClick(() => {
      if (activeFieldId.current === fieldId_0) {
        return;
      }
      activeFieldId.current = fieldId_0;
      onFocusField(fieldId_0);
    }) : undefined;
    $[11] = onFocusField;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== focusedFieldId || $[14] !== onCloseField) {
    t11 = () => {
      const fieldId_1 = focusedFieldId;
      afterClick(() => {
        if (activeFieldId.current !== fieldId_1) {
          return;
        }
        activeFieldId.current = undefined;
        onCloseField?.();
      });
    };
    $[13] = focusedFieldId;
    $[14] = onCloseField;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== onSelectEvidence) {
    t12 = onSelectEvidence ? (fieldId_2, evidence) => afterClick(() => {
      activeFieldId.current = fieldId_2;
      onSelectEvidence(fieldId_2, evidence);
    }) : undefined;
    $[16] = onSelectEvidence;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t12 || $[21] !== t9) {
    t13 = {
      onPointerDownCapture: t8,
      onEditingChange: t9,
      onFocusField: t10,
      onCloseField: t11,
      onSelectEvidence: t12
    };
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
}
function _temp(change) {
  return change();
}